__turbopack_context__.v({
  "background-image-wrapper": "DevEnvironment-module-scss-module__FcB7nW__background-image-wrapper",
  "brand-wrapper": "DevEnvironment-module-scss-module__FcB7nW__brand-wrapper",
  "collapsable-content-wrapper": "DevEnvironment-module-scss-module__FcB7nW__collapsable-content-wrapper",
  "color-wrapper": "DevEnvironment-module-scss-module__FcB7nW__color-wrapper",
  "logo-wrapper": "DevEnvironment-module-scss-module__FcB7nW__logo-wrapper",
  "order-wrapper": "DevEnvironment-module-scss-module__FcB7nW__order-wrapper",
  "settings-header": "DevEnvironment-module-scss-module__FcB7nW__settings-header",
  "settings-header-wrapper": "DevEnvironment-module-scss-module__FcB7nW__settings-header-wrapper",
  "settings-icon": "DevEnvironment-module-scss-module__FcB7nW__settings-icon",
  "wrapper": "DevEnvironment-module-scss-module__FcB7nW__wrapper",
  "wrapper-expanded": "DevEnvironment-module-scss-module__FcB7nW__wrapper-expanded",
});
